import { Components } from "formiojs";
const CheckBoxComponent = Components.components.checkbox;

export default class ConfirmationComponent extends CheckBoxComponent {
  static schema() {
    return CheckBoxComponent.schema({
      type: "confirmation",
      label: "Confirmation",
      key: "confirmation",
      confirmationText: "",
      linkText: "",
      linkUrl: "",
      validate: {
        required: true,
      },
    });
  }

  get inputInfo() {
    return {
      // @ts-expect-error - It's present in source code but not in types. There is no exact type for Checkbox component
      ...super.inputInfo,
      label: this.confirmLabel,
    };
  }

  static builderInfo = {
    title: "Confirmation",
    icon: "check",
    key: "confirmation",
    schema: ConfirmationComponent.schema(),
  };

  get confirmLabel() {
    return [
      this.schema.confirmationText.replace(
      "[link]",
      `<a href="${this.schema.linkUrl}" class="confirmation-link" target="_blank">${this.schema.linkText}</a>`
    ),
      '<span class="asterisk">*</span>',
    ].join(' ');
  }

  render() {
    // NOTE: Will take parent class template
    return super.render(null);
  }
}
